import { render, staticRenderFns } from "./register-companies.vue?vue&type=template&id=6e7e7c41&scoped=true"
import script from "./register-companies.vue?vue&type=script&lang=js"
export * from "./register-companies.vue?vue&type=script&lang=js"
import style0 from "./register-companies.vue?vue&type=style&index=0&id=6e7e7c41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e7c41",
  null
  
)

export default component.exports